var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3509_29660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3121 6.95598V7.51267C13.3114 8.81751 12.8889 10.0872 12.1076 11.1322C11.3263 12.1773 10.2281 12.9419 8.97682 13.3118C7.72553 13.6818 6.38816 13.6374 5.16418 13.1852C3.9402 12.733 2.89519 11.8973 2.18499 10.8026C1.47479 9.70798 1.13747 8.41309 1.22332 7.11108C1.30918 5.80906 1.81361 4.56968 2.66139 3.57778C3.50918 2.58587 4.65488 1.89459 5.92764 1.60703C7.2004 1.31946 8.53202 1.45103 9.7239 1.9821",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.312 2.67188L7.26109 8.72888L5.4458 6.91359",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3509_29660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5223,
    height: 14.5223,
    fill: "white",
    transform: "translate(0 0.251465)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessons);
export default __webpack_public_path__ + "static/media/lessons.e9df2d57ab1a735c1a57cb2c4c693417.svg";
export { ForwardRef as ReactComponent };